<template>
  <van-list
    v-model:loading="data.loading"
    :finished="data.finished"
    finished-text="没有更多了"
    @load="data.onLoad"
>
  <div class="masonry">
      <div class="masonry-item" @click="data.quitImg(item)"  v-for="item in data.colList" :key="item.img_url">
        <img v-if="item.image_detail" :src="item.image_detail[0]" alt="">
        <div v-else>
          <div class="loadingio-spinner-double-ring-aavfn585i2h"><div class="ldio-rg45hfj5l1">
          <div></div>
          <div></div>
          <div><div></div></div>
          <div><div></div></div>
          </div></div>
        </div>
        <div class="content">{{ item.name }}</div>
        <div class="btn" @click.stop="data.quit(item)">一键创作同款</div>
      </div>
  </div>
  </van-list>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed, nextTick } from 'vue';
import { useCounterStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import { artGallery } from '@/api/img'
import {again} from'@/api/img'
import {appDeteil} from'@/api/text'
import cross from '@/assets/cross.png'  
import { showFailToast } from 'vant';
/*
* 仓库
*/
const store = useCounterStore();
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
* 数据部分
*/
const data = reactive({})
const leftCol = ref(null)
const rightCol = ref(null)
data.loading = false
data.finished = false
data.page = 1
data.colList = []
data.height = 0 
data.col1 = []
data.col2 = []
data.onLoad = () => {
 data.getList()
}

data.quitImg = (e) =>{
   localStorage.setItem('imgInfo',JSON.stringify(e))
   router.push({name:'imgInfo'})
}


data.quit = (e) =>{
  let userInfo = localStorage.getItem('userInfo')
  if (!userInfo) {
    showFailToast({
      message:'请先登录',
      icon:cross
    })
    router.push({
      name:'login',
    })
  }
  again({
    app_id:e.app_id,
    chat_id:e.same_model_id,
    is_open:JSON.parse(userInfo).is_info_public
  }).then(res=>{
    if (res.code === 200) {
      appDeteil({app_id:e.app_id}).then(res=>{
        store.setCreateFlag(false)
        store.setGenerate(false);
          store.copywritingFalse();
          store.setAppInfo(res.data)
          localStorage.setItem('appInfo',JSON.stringify(res.data))
          router.push({name:'appliance'})
      })
    }
  }) 
}
data.getList = () =>{
  artGallery({
    page:data.page,
    limit:10,
  }).then(res=>{
    if (res.code === 200 && res.data.data) {
       data.colList.push(...res.data.data)
      if (res.data.data.length<10) {
          data.finished = true
        } else {
          data.page = data.page + 1
          data.finished = false
        }
        data.loading = false
    } else {
      data.finished = true
      data.loading = false
    }
  })
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
})
onMounted(() => {
  // data.clearList(data.colList)
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
})
watchEffect(()=>{
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
  .van-list {
   overflow: hidden;
   position: relative;
   overflow-y: auto;
   height:calc(100vh - 146px);
   }
   .van-list::-webkit-scrollbar {
    display: none;
  }
  .masonry {
  margin-top: 10px;
  min-height:calc(100vh - 146px);
  column-count: 2;
  column-gap: 1em;
  padding: 0 10px;
}
.masonry-item {
  position: relative;
  break-inside: avoid;
  margin-bottom: 1em;
  img{
   width: 100%;
   height: 100%;
   border-radius: 12px;
  }
.content{
   margin-top: 12px;
   color: #F7F5FF;
   font-size: 26px;
   font-weight: 300;
}
.btn{
   margin-top: 12px;
   height: 58px;
   background: #8368FC;
   border-radius: 10px;
   color: #FFFFFF;
   font-size: 28px;
   font-weight: 400;
   text-align: center;
   line-height: 58px;
} 
}
@keyframes ldio-rg45hfj5l1 {
  0% { transform: rotate(0) }
  100% { transform: rotate(360deg) }
}
.ldio-rg45hfj5l1 div { box-sizing: border-box!important }
.ldio-rg45hfj5l1 > div {
  position: absolute;
  width: 144px;
  height: 144px;
  top: 28px;
  left: 28px;
  border-radius: 50%;
  border: 16px solid #000;
  border-color: #e15b64 transparent #e15b64 transparent;
  animation: ldio-rg45hfj5l1 1s linear infinite;
}

.ldio-rg45hfj5l1 > div:nth-child(2), .ldio-rg45hfj5l1 > div:nth-child(4) {
  width: 108px;
  height: 108px;
  top: 46px;
  left: 46px;
  animation: ldio-rg45hfj5l1 1s linear infinite reverse;
}
.ldio-rg45hfj5l1 > div:nth-child(2) {
  border-color: transparent #f8b26a transparent #f8b26a
}
.ldio-rg45hfj5l1 > div:nth-child(3) { border-color: transparent }
.ldio-rg45hfj5l1 > div:nth-child(3) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.ldio-rg45hfj5l1 > div:nth-child(3) div:before, .ldio-rg45hfj5l1 > div:nth-child(3) div:after { 
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: -16px;
  left: 48px;
  background: #e15b64;
  border-radius: 50%;
  box-shadow: 0 128px 0 0 #e15b64;
}
.ldio-rg45hfj5l1 > div:nth-child(3) div:after {
  left: -16px;
  top: 48px;
  box-shadow: 128px 0 0 0 #e15b64;
}

.ldio-rg45hfj5l1 > div:nth-child(4) { border-color: transparent; }
.ldio-rg45hfj5l1 > div:nth-child(4) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.ldio-rg45hfj5l1 > div:nth-child(4) div:before, .ldio-rg45hfj5l1 > div:nth-child(4) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: -16px;
  left: 30px;
  background: #f8b26a;
  border-radius: 50%;
  box-shadow: 0 92px 0 0 #f8b26a;
}
.ldio-rg45hfj5l1 > div:nth-child(4) div:after {
  left: -16px;
  top: 30px;
  box-shadow: 92px 0 0 0 #f8b26a;
}
.loadingio-spinner-double-ring-aavfn585i2h {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: #323647;
}
.ldio-rg45hfj5l1 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-rg45hfj5l1 div { box-sizing: content-box; }
</style>